var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DynamicForm',{ref:"dynamicForm",on:{"formDirty":_vm.onDirtyDynamicForm},model:{value:(_vm.schema),callback:function ($$v) {_vm.schema=$$v},expression:"schema"}})}
var staticRenderFns = []

export { render, staticRenderFns }